import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";

export function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main className="center-screen">
        <div className="loading-card">Cargando sesión…</div>
      </main>
    );
  }

  if (user) {
    return <Outlet />;
  }

  const returnTo = `${location.pathname}${location.search}${location.hash}`;

  return (
    <Navigate
      to={`/login?returnTo=${encodeURIComponent(returnTo)}`}
      replace
    />
  );
}
